/* eslint-disable max-lines */
/* eslint-disable react/jsx-max-depth */
/* eslint-disable max-lines */
import PropTypes from 'prop-types';
import queryString from 'querystring';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import DataTable from '../../components/elements/DataTable';
import Text from '../../components/fields/Text';
import {
  fetchCities,
  fetchProvinces,
  fetchRegionals,
} from '../../components/layouts/PageBase/actions';
import { useDebounce } from '../../utils/hooks';
import styles from './styles.scoped.css';
// import { formatDateTime } from '../../utils/format';
import Card from '../../components/elements/Card';
import ErrorHandler from '../../components/elements/ErrorHandler';
import { AppContext } from '../../contexts';
// import { processColor, processStatus } from './constants';
// import Tag from '../../components/elements/Tag';
// import classNames from '../../utils/classNames';
import dayjs from 'dayjs';
import moment from 'moment';
import BadgeStatus from '../../components/elements/BadgeStatus/BadgeStatus';
import Button from '../../components/elements/Button';
import LoadingBars from '../../components/elements/LoadingBars/LoadingBars';
import { ModalDownloadOutOfRange } from '../../components/elements/ModalDownload';
import ScrollToTop from '../../components/elements/ScrollToTop';
import ModalError from '../../components/fragments/ModalError/ModalError';
import RegistrationFilter from '../../components/fragments/RegistrationFilter/RegistrationFilter';
import { thousand } from '../../utils/format';
import {
  clearError,
  fetchDownloadFailedRegistration,
  fetchFailedMerchantRegistrations,
  seterrorUnduh,
} from './actions';

export default function FailedMerchantRegistration({ category }) {
  const { setBreadcrumbs } = useContext(AppContext);

  const dispatch = useDispatch();
  const location = useLocation();

  const ref = useRef(true);
  const inputRef = useRef(null);
  // const navigate = useNavigate();

  // const userRegion = getRegional();
  // const adminId = getAdminId();

  const [search, setSearch] = useState('');
  const [fromDate, setFromDate] = useState(
    moment().subtract(6, 'day').toDate()
  );
  const [toDate, seToDate] = useState(moment().toDate());
  const [page, setPage] = useState(1);
  const [modalOutRangeVisible, setModalOutRangeVisible] = useState(false);
  const [modalError, setModalError] = useState(false);

  const {
    dataFailedMerchantRegistrations: { data, meta },
    // dataDownloadRegistrationReport: { generating = false, link = null },
    datadownloadFailedRegistration,
    isLoadingdownloadFailedRegistration,
    isLoadingFailedMerchantRegistrations,
    messageMerchantRegistrations,
    dataFilter,
    isLoadingErrorUnduh,
    messageErrorUnduh,
    // isLoadingDownloadRegistrationReport,
  } = useSelector((s) => s.merchantRegistrations);

  const { dataDetailUser } = useSelector((state) => state.pageBase);

  const {
    regional = dataDetailUser?.regionalId
      ? JSON.stringify([dataDetailUser?.regionalId])
      : '',
    provinceId = dataDetailUser?.provinceId,
    cityId = dataDetailUser.cities ?? '',
    districtId = dataFilter.districtId ?? '',
    villageId = '',
    registrationStatus = 'all',
    outletType = '',
    status = '',
    wave = '',
    agenId = '',
    startDate = '',
    endDate = '',
    samId = dataDetailUser?.sam?.id
      ? JSON.stringify([dataDetailUser?.sam?.id])
      : '',
    sbmId = dataDetailUser?.sbm?.id
      ? JSON.stringify([dataDetailUser?.sbm?.id])
      : '',
  } = queryString.parse(location.search.replace('?', ''));

  // const {
  //   dataDetailUser
  // } = useSelector((s) => s.pageBase);

  useEffect(() => {
    setBreadcrumbs(['Registrasi Pangkalan LPG 3 Kg']);
    dispatch(fetchRegionals());
    dispatch(fetchProvinces());
    if (provinceId) {
      dispatch(fetchCities(provinceId));
    }
  }, []);

  useEffect(() => {
    if (!isLoadingFailedMerchantRegistrations && data.length <= 100) {
      inputRef.current?.focus();
    }
  }, [isLoadingFailedMerchantRegistrations]);

  const debounceParams = useDebounce(
    category +
      regional +
      provinceId +
      cityId +
      districtId +
      villageId +
      registrationStatus +
      search +
      outletType +
      status +
      samId +
      sbmId +
      wave +
      agenId +
      startDate +
      endDate +
      500
  );

  function getAllParams(page, type = 'search') {
    const isPage = type === 'search' && { page: page ? page : 1 };
    let allParams = {
      regional: regional === 'All' ? '' : regional,
      provinceId: provinceId === 'All' ? '' : provinceId,
      cityId: cityId === 'All' ? '' : cityId,
      districtId: districtId === 'All' ? '' : districtId,
      villageId: villageId === 'All' ? '' : villageId,
      search,
      ...isPage,
      startDate: moment(fromDate).format('YYYY-MM-DD'),
      endDate: moment(toDate).format('YYYY-MM-DD'),
      status: status,
      wave: wave,
      agenId: agenId,
      samId: samId,
      sbmId: sbmId,
    };

    if (outletType) {
      allParams.outletType = outletType;
    }
    if (registrationStatus !== 'all') {
      allParams.registrationStatus = registrationStatus;
    }
    return allParams;
  }

  const fetchRegistrationList = () => {
    dispatch(fetchFailedMerchantRegistrations(getAllParams()));
    dispatch(clearError());
  };

  useEffect(() => {
    if (page > 1) {
      dispatch(fetchFailedMerchantRegistrations(getAllParams(page)));
    }
  }, [page]);

  useEffect(() => {
    setFromDate(
      dataFilter?.registrationDate?.length > 1
        ? dataFilter.registrationDate[0]
        : fromDate
    );
    seToDate(
      dataFilter?.registrationDate?.length > 1
        ? dataFilter.registrationDate[1]
        : toDate
    );
    // fetchRegistrationList();
  }, [dataFilter]);

  useEffect(() => {
    setPage(1);
    fetchRegistrationList();
  }, [debounceParams]);

  useEffect(() => {
    if (messageErrorUnduh && !isLoadingErrorUnduh) {
      setModalError(true);
    }
  }, [messageErrorUnduh, isLoadingErrorUnduh]);

  useEffect(() => {
    if (
      datadownloadFailedRegistration &&
      !isLoadingdownloadFailedRegistration &&
      !ref.current
    ) {
      let a = document.createElement('a');
      a.href = datadownloadFailedRegistration?.fileUrl;
      a.click();
      ref.current = true;
    }
  }, [datadownloadFailedRegistration, isLoadingdownloadFailedRegistration]);

  const download = () => {
    const date1 = dayjs(fromDate);
    const date2 = dayjs(toDate);
    const diff = date2.diff(date1, 'day');
    if (diff <= 31) {
      ref.current = false;
      dispatch(fetchDownloadFailedRegistration(getAllParams(1, 'download')));
    } else {
      dispatch(seterrorUnduh());
    }
  };

  const renderdetail = (id) => {
    return (
      <Link
        className={styles['detail-btn']}
        to={'/merchant/registrasi-pangkalan/' + id + '/failed'}
        type="primary"
      >
        Detail
      </Link>
    );
  };

  const renderStatus = (status) => {
    return <BadgeStatus label={status} />;
  };

  const renderReason = (reasons) => {
    return (
      <ul>
        {reasons.map((reason, index) => (
          <li key={index}>{reason}</li>
        ))}
      </ul>
    );
  };

  const column = [
    { heading: 'Tanggal Registrasi', value: 'registrationDate' },
    { heading: 'Jam', value: 'registrationTime' },
    { heading: 'ID Registrasi', value: 'registrationId' },
    { heading: 'Nama Pangkalan LPG 3 Kg', value: 'storeName' },
    { heading: 'Alasan', value: ({ reasons }) => renderReason(reasons) },
    { heading: 'Petinjau', value: 'reviewer' },
    { heading: 'Status', value: ({ status }) => renderStatus(status) },
    {
      heading: 'Action',
      value: ({ failedId }) => renderdetail(failedId),
      className: '',
    },
  ];

  if (messageMerchantRegistrations) {
    return <ErrorHandler message={messageMerchantRegistrations} />;
  }

  return (
    <div className={styles.mainRoot}>
      <RegistrationFilter type={'failed'} />
      <Card className={styles['table-filter-container']}>
        {dataDetailUser?.userType === 'superadmin' && (
          <Button
            className={styles['upload-regist-btn']}
            disabled={isLoadingdownloadFailedRegistration}
            onClick={() => download()}
          >
            {isLoadingdownloadFailedRegistration ? (
              <LoadingBars size={2} />
            ) : (
              <img src="assets/ic-download.svg" />
            )}
            Unduh Data
          </Button>
        )}

        <span>
          Menampilkan <strong>{thousand(meta.totalData)}</strong> data
        </span>
        <div className={styles['filter-wrap']}>
          <div className={styles.filters}>
            <Text
              className={styles['search-bar']}
              disabled={isLoadingFailedMerchantRegistrations}
              hideLabel
              inputProps={{
                ref: inputRef,
                placeholder: 'Cari data...',
                value: search,
                icon: 'ic-search.svg',
                onChange: (e) => setSearch(e.target.value),
              }}
            />
          </div>
        </div>
      </Card>
      <br />
      <div className={styles['table-container']}>
        <DataTable
          className={styles.table}
          column={column}
          data={data}
          endTreshould={200}
          loading={isLoadingFailedMerchantRegistrations}
          meta={meta}
          onEndReached={() => setPage(page + 1)}
          onRefresh={fetchRegistrationList}
          withIndex
        />
      </div>
      <ModalDownloadOutOfRange
        onClose={() => setModalOutRangeVisible(false)}
        open={modalOutRangeVisible}
      />
      <ModalError open={modalError} setModalError={setModalError} />
      <ScrollToTop />
    </div>
  );
}

FailedMerchantRegistration.propTypes = {
  category: PropTypes.shape({
    categoryId: PropTypes.string,
    unit_name: PropTypes.string,
    unit_symbol: PropTypes.string,
  }),
};
